import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { richTextForQuill } from "../utils/richTextForQuill";

const ProfileSetting = ({
  formData,
  handleChange,
  useTextLogo,
  setUseTextLogo,
  handleLogoChange,
  handleTextLogoChange,
  isLoaded,
  Autocomplete,
  autocompleteRef,
  handlePlaceChanged,
  ReactQuill,
  setFormData,
  originalFormData,
  handleSubmit,
  error
}) => {
  const [hasChanges, setHasChanges] = useState(false);
  const url = API_BASE_URL
  useEffect(() => {
    if (!originalFormData) return;
    const changed = JSON.stringify(formData) !== JSON.stringify(originalFormData);
    setHasChanges(changed);
  }, [formData, originalFormData]);


  console.log(formData)
  return (
    <div className="profile-form-container">
      {/* Name */}
      <div className="profile-form-group">
        <label className="profile-form-label">Name</label>
        <input
          type="text"
          name="full_name"
          value={formData.full_name || ""}
          onChange={handleChange}
          className="profile-form-input"
        />
      </div>

      {/* Email */}
      <div className="profile-form-group">
        <label className="profile-form-label">Email</label>
        <input
          type="email"
          name="email"
          value={formData.email || ""}
          onChange={handleChange}
          className="profile-form-input"
        />
      </div>

      {/* ID (readonly) */}
      <div className="profile-form-group">
        <label className="profile-form-label">User ID</label>
        <input
          type="text"
          value={formData.main_id || ""}
          disabled
          className="profile-form-input profile-readonly"
        />
      </div>

      {/* Status */}
      <div className="profile-form-group">
        <label className="profile-form-label">Status</label>
        <input
          type="text"
          name="status"
          disabled
          value={formData.status || ""}
          className="profile-form-input"
        />
      </div>

      {/* Type */}
      <div className="profile-form-group">
        <label className="profile-form-label">Type</label>
        <input
          type="text"
          name="type"
          disabled
          value={formData.type || ""}
          className="profile-form-input"
        />
      </div>

      {/* Mobile Number */}
      <div className="profile-form-group">
        <label className="profile-form-label">Mobile Number</label>
        <input
          type="text"
          name="mobile"
          value={formData.mobile || ""}
          onChange={handleChange}
          className="profile-form-input"
        />
      </div>

      <div className="profile-form-group full-span">
        <label className="profile-form-label">Tax No</label>
        <input
          type="text"
          name="taxNo"
          value={formData.taxNo || ""}
          onChange={handleChange}
          className="profile-form-input"
        />
      </div>

      {/* Invoice Address */}
      <div className="profile-form-group full-span">
        <label className="profile-form-label">Invoice Address</label>
        <input
          type="text"
          name="office_address"
          value={formData.office_address || ""}
          onChange={handleChange}
          className="profile-form-input"
        />
      </div>

      {/* Address */}
      <div className="profile-form-group full-span">
        <label className="profile-form-label">Address</label>
        {isLoaded && (
          <Autocomplete
            onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
            onPlaceChanged={handlePlaceChanged}
            className="full-span"
          >
            <input
              type="text"
              name="google_address"
              value={formData.google_address || ""}
              onChange={handleChange}
              className="profile-form-input"
              placeholder="Search Google Address"
            />
          </Autocomplete>
        )}
      </div>

      <div className="profile-form-group">
        <label className="profile-form-label">Website Url</label>
        <input
          type="text"
          name="website_link"
          value={formData.website_link || ""}
          onChange={handleChange}
          className="profile-form-input"
        />

        {error.website_link && (
          <p className="error-text">{error.website_link}</p>
        )}
      </div>
      {/* Customer Note */}
      <div className="profile-form-group full-span">
        <label className="profile-form-label">Customer Note</label>
        <ReactQuill
          theme="snow"
          value={richTextForQuill(formData.custom_note)}
          onChange={(value) =>
            setFormData((prev) => ({ ...prev, custom_note: value }))
          }
          className="profile-form-quill"
          placeholder="Add Customer Note"
        />
      </div>



      {/* Tagline */}
      <div className="profile-form-group full-span tag-line">
        <label className="profile-form-label">Tagline</label>
        <input
          type="text"
          name="tag_line"
          value={formData.tag_line || ""}
          onChange={handleChange}
          className="profile-form-input"
        />
      </div>

      {/* Logo Type */}
      <div className="profile-form-group full-span">
        <label className="profile-form-label">Logo Type</label>
        <div className="profile-radio-group">
          <label>
            <input
              type="radio"
              checked={!useTextLogo}
              onChange={() => setUseTextLogo(false)}
            />
            <span>Image</span>
          </label>
          <label>
            <input
              type="radio"
              checked={useTextLogo}
              onChange={() => setUseTextLogo(true)}
            />
            <span>Text</span>
          </label>
        </div>
      </div>

      {/* Logo Input */}
      <div className="profile-form-group full-span">
        <label className="profile-form-label">Logo</label>
        {useTextLogo ? (
          <input
            type="text"
            name="orignal_logoname"
            value={formData.orignal_logoname || ""}
            onChange={handleTextLogoChange}
            className="profile-form-input"
          />
        ) : (
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            className="profile-form-file"
          />
        )}
      </div>

      {/* Logo Preview */}
      {!useTextLogo && formData.profilePic && (
        <div className="profile-form-group full-span">
          <label className="profile-form-label">Preview</label>
          <img
            src={
              typeof formData.profilePic === "string"
                ? `${url}/uploads/profile/${formData.profilePic}`
                : URL.createObjectURL(formData.profilePic)
            }
            alt="Logo"
            className="profile-logo-preview"
          />
        </div>
      )}

      {/* Save Button */}
      {hasChanges && (
        <div className="profile-form-group full-span">
          <button className="profile-save-btn" onClick={handleSubmit}>
            Save Changes
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileSetting;
